var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: { "data-template": "company", "data-size": "2x1" },
    },
    [
      _c("div", { staticClass: "go-card-main" }, [
        _c("div", { staticClass: "go-card-body" }, [
          _c("div", { staticClass: "go-block-header" }, [
            _c("div", { staticClass: "go-company-info" }, [
              _c("div", { staticClass: "go-card-img" }, [
                _c("img", {
                  attrs: { loading: "lazy", src: _vm.avatar },
                  on: { error: _vm.setDefaultImage, click: _vm.viewDetail },
                }),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "go-card-title",
                    on: { click: _vm.viewDetail },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.formModel.title
                            ? _vm.formModel.title
                            : _vm.formModel.other_info.cmpNm
                        ) +
                        "\n              "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "go-stock-info" }, [
                  _c("div", { staticClass: "go-stock-price" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formModel.other_info.stckCrntPrice) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: _vm.isIncrease
                        ? "go-stock-gap status-up"
                        : "go-stock-gap status-down",
                    },
                    [
                      _c("span", { staticClass: "go-gap-price" }, [
                        _c("span", { staticClass: "go-status-icon" }),
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.formModel.other_info.stckVersusBfrt) +
                            "\n                  "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-gap-rate" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.formModel.other_info.stckFlctsrt) +
                            "\n                  "
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-block-body" }, [
            _c("p", { staticClass: "go-card-desc" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.formModel.source_summary
                      ? _vm.formModel.source_summary
                      : _vm.formModel.other_info.newsSummary
                  ) +
                  "\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-card-footer" }, [
          _c("div", { staticClass: "go-block-header" }, [
            _c("div", { staticClass: "go-emotion" }, [
              _c("div", { staticClass: "go-list-item" }, [
                _c("strong", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("companyCard.label.market")) +
                      "\n              "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "go-icon-area go-tooltip-area",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-original-title": "Positive",
                    },
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          value: { customClass: "go-tooltip" },
                          expression: "{ customClass: 'go-tooltip' }",
                          modifiers: { hover: true },
                        },
                      ],
                      class: [
                        "go-icon-24",
                        "go-icon-emotion-" + _vm.stckSentimentIdx,
                      ],
                      attrs: { title: _vm.stckSentimentIdx },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-list-item" }, [
                _c("strong", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("companyCard.label.news")) +
                      "\n              "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "go-icon-area go-tooltip-area",
                    attrs: { "data-toggle": "tooltip", title: "Neutral" },
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          value: { customClass: "go-tooltip" },
                          expression: "{ customClass: 'go-tooltip' }",
                          modifiers: { hover: true },
                        },
                      ],
                      class: [
                        "go-icon-24",
                        "go-icon-emotion-" + _vm.publicInfoSentimentIdx,
                      ],
                      attrs: { title: _vm.publicInfoSentimentIdx },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-list-item" }, [
                _c("strong", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("companyCard.label.social")) +
                      "\n              "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "go-icon-area go-tooltip-area",
                    attrs: { "data-toggle": "tooltip", title: "Negative" },
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          value: { customClass: "go-tooltip" },
                          expression: "{ customClass: 'go-tooltip' }",
                          modifiers: { hover: true },
                        },
                      ],
                      class: [
                        "go-icon-24",
                        "go-icon-emotion-" + _vm.socialSentimentIdx,
                      ],
                      attrs: { title: _vm.socialSentimentIdx },
                    }),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-elements" }, [
              _c(
                "button",
                {
                  class: [
                    "btn go-btn-icon",
                    { active: _vm.formModel.subscribeStatus === "SUBSCRIBE" },
                  ],
                  attrs: {
                    type: "button",
                    "data-toggle": "button",
                    "aria-pressed":
                      _vm.formModel.subscribeStatus !== "UN_SUBSCRIBE",
                    disabled: _vm.isLoadingSubcribe,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.subscribeToCompany.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      class:
                        _vm.formModel.subscribeStatus === "SUBSCRIBE"
                          ? "go-tooltip-area go-toggle-on"
                          : "go-tooltip-area go-toggle-off",
                      attrs: {
                        "data-toggle": "tooltip",
                        title: _vm.$t("companyCard.label.subscribe"),
                      },
                    },
                    [
                      _c("i", {
                        class:
                          _vm.formModel.subscribeStatus === "SUBSCRIBE"
                            ? "go-icon-18 go-icon-subscribe-on2"
                            : "go-icon-18 go-icon-subscribe",
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-block-body" }, [
            _c("div", { staticClass: "go-row" }, [
              _c("div", { staticClass: "go-col go-col-left" }, [
                _c("ul", { staticClass: "go-card-sub-list" }, [
                  _c("li", { staticClass: "go-list-item" }, [
                    _c("div", { staticClass: "go-card-sub" }, [
                      _c("div", { staticClass: "go-card-label" }, [
                        _c("em", { staticClass: "go-text" }, [
                          _vm._v(
                            "\n                      " +
                              _vm._s(
                                _vm.formModel.other_info.insightReportType
                              ) +
                              "\n                      "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "go-card-img",
                          on: { click: _vm.viewDetailReport },
                        },
                        [
                          _c("img", {
                            attrs: { loading: "lazy", src: _vm.reportImage },
                            on: { error: _vm.setDefaultReportImage },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-body" }, [
                        _c(
                          "a",
                          {
                            staticClass: "go-card-title",
                            on: { click: _vm.viewDetailReport },
                          },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(
                                  _vm.formModel.other_info.insightReportTitle
                                ) +
                                "\n                      "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-col go-col-right" }, [
                _c("ul", { staticClass: "go-card-sub-list" }, [
                  _c("li", { staticClass: "go-list-item" }, [
                    _c("div", { staticClass: "go-card-sub" }, [
                      _c("div", { staticClass: "go-card-body" }, [
                        _c("div", { staticClass: "go-card-info" }, [
                          _c("span", { staticClass: "go-info-item go-label" }, [
                            _c("em", { staticClass: "go-text" }, [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(
                                    _vm.formModel.other_info.subWidgetType
                                  ) +
                                  "\n                          "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.formModel.other_info.subWidgetContent &&
                        _vm.formModel.other_info.subWidgetContent
                          .stockChatsSummarys
                          ? _c(
                              "a",
                              {
                                staticClass: "go-card-title",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.getDataDetail.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.formModel.other_info.subWidgetContent
                                        .stockChatsSummarys[0].summaryContent
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.isContentNew
          ? _c("div", { staticClass: "go-card-new" }, [_vm._v("New")])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }